import React from "react";
import { Toaster } from "react-hot-toast";
import { CampaignTypeFormData } from "../types/campaignType.types";
import { useCreateCampaignTypeModal } from "../hooks/useCreateCampaignTypeModal";

interface CreateCampaignTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CampaignTypeFormData) => void;
}

const CreateCampaignTypeModal: React.FC<CreateCampaignTypeModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const { formData, errors, isLoading, handleChange, handleClearAll, handleSubmit } =
    useCreateCampaignTypeModal({ isOpen, onClose, onSubmit });

  const requiredField = <span className="text-danger ms-1">*</span>;

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div
        className={`modal-backdrop-custom ${isOpen ? "open" : "closed"}`}
        onClick={onClose}
      ></div>
      <div className={`modal-custom ${isOpen ? "open" : "closed"}`}>
        <div className="modal-content CampaignTypeFormContent">
          <div className="modal-header-custom">
            <h5 className="modal-title-custom">Create Campaign Type</h5>
            <button type="button" className="btn-close-custom" onClick={onClose}>
              <span className="icon-close"></span>
            </button>
          </div>
          <div className="modal-body-custom">
            <div className="modal-body-content">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 col-lg-12 mb-3 input-group-custom">
                    <label className="form-label" htmlFor="name">
                      Campaign Type Name{requiredField}
                    </label>
                    <div className="input-with-icon">
                      <span className="input-icon icon-campaign"></span>
                      <input
                        type="text"
                        name="name"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Enter Campaign Type Name"
                        maxLength={100}
                        className={`form-control-custom ${errors.name ? "is-invalid" : ""}`}
                        disabled={isLoading}
                      />
                      {errors.name && (
                        <div className="invalid-feedback text-danger">
                          {errors.name}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer-custom">
              <button
                type="button"
                onClick={handleClearAll}
                className="btn-custom btn-cancel"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                className="btn-custom btn-primary-custom"
                disabled={isLoading}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateCampaignTypeModal;
